import axiosInstance from "../../../interceptor/axiosInstance";
import {CHAPTERS} from "../../../routes/routeConstants/apiRoutes";
import {deserialize} from "serializr";
import {PaginationModel} from "../../../models/PaginationModel/pagination.model";
import Notification from "../../../shared/components/Notification";
import {NotificationTypes} from "../../../enums/notificationTypes";
import {ChapterModel} from "../../../models/CourseModels/ChapterModel/chapter.model";

export default class ChapterService {
    static getChaptersList(
        queryParams: string,
        onSuccess: Function,
        onError: Function,
        onFinal: () => void
    ) {
        return axiosInstance
            .get(CHAPTERS+queryParams)
            .then(response => {
                const chapters = deserialize(ChapterModel, response.data['chaptors']);
                const pageMeta = deserialize(PaginationModel, response.data['meta']);
                onSuccess(chapters, pageMeta);
            })
            .catch(error => {
                Notification({
                    message: "Failed",
                    description: "Unable to fetch the chapters list",
                    type: NotificationTypes.ERROR
                });
                onError(error);
            })
            .finally(onFinal)
    }

    static createChapter(
        data:any,
        onSuccess: Function,
        onError: Function,
        onFinal: () => void
    ) {
        return axiosInstance
            .post(CHAPTERS,data)
            .then(response => {
                const chapter = deserialize(ChapterModel, response.data['chaptor']);
                onSuccess(chapter);
            })
            .catch(error => {
                Notification({
                    message: "Failed",
                    description: "Unable to create the chapter",
                    type: NotificationTypes.ERROR
                });
                onError(error);
            })
            .finally(onFinal)
    }

    static updateChapter(
        id: number,
        data:any,
        onSuccess: Function,
        onError: Function,
        onFinal: () => void
    ) {
        return axiosInstance
            .put(CHAPTERS+`/${id}`,data)
            .then(response => {
                const chapter = deserialize(ChapterModel, response.data['chaptor']);
                onSuccess(chapter);
            })
            .catch(error => {
                Notification({
                    message: "Failed",
                    description: "Unable to update the chapter",
                    type: NotificationTypes.ERROR
                });
                onError(error);
            })
            .finally(onFinal)
    }

    static deleteChapter(
        id: number,
        onSuccess: Function,
        onError: Function,
        onFinal: () => void
    ) {
        return axiosInstance
            .delete(CHAPTERS+`/${id}`)
            .then(() => {
                onSuccess();
            })
            .catch(error => {
                Notification({
                    message: "Failed",
                    description: "Unable to update the chapter",
                    type: NotificationTypes.ERROR
                });
                onError(error);
            })
            .finally(onFinal)
    }

    static updateChapterPosition(
        id: string,
        data:any,
        onSuccess: Function,
        onError: Function,
        onFinal: () => void
    ) {
        return axiosInstance
            .put(CHAPTERS+`/${id}/position`,data)
            .then(response => {
                const chapter = deserialize(ChapterModel, response.data['chaptor']);
                Notification({
                    message: "Success",
                    description: chapter.name+" position has been updated successfully",
                    type: NotificationTypes.SUCCESS
                });
                onSuccess(chapter);
            })
            .catch(error => {
                Notification({
                    message: "Failed",
                    description: "Unable to update the chapter position",
                    type: NotificationTypes.ERROR
                });
                onError(error);
            })
            .finally(onFinal)
    }
}
